import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonHeader, IonFooter, IonContent } from '@ionic/react';
import ReactDOM from 'react-dom';


import { ShowProductPicsModal } from './Modal_ShowProductPics';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { ViewInvoiceModal } from '../../../zInternal_Features/merchant/components/Modal_ViewInvoice';
import { ViewRecipeDetailDataModal } from './Modal_Recipe_Details';

//import '../../../../css/qavaApp.css';
import '../../../css/layout.css'


export function Modal_RecipeList (props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [menuType, setMenuType] = useState(null);
    let [productID, setProductID] = useState(null);
    let [productName, setProductName] = useState(null);

    let [viewIonPopover, setvViewIonPopover] = useState(false);

    
    let [viewInventoryAvailableProducts, setViewInventoryAvailableProducts] = useState([]);
    let [showProductDetails, setShowProductDetails] = useState(false);

    let [viewInventoryAvailableProducts_food, setViewInventoryAvailableProducts_food] = useState([]);
    let [viewInventoryAvailableProducts_drinks, setViewInventoryAvailableProducts_drinks] = useState([]);
    let [viewInventoryAvailableProducts_hotel, setViewInventoryAvailableProducts_hotel] = useState([]);
    let [viewInventoryAvailableProducts_misc, setViewInventoryAvailableProducts_misc] = useState([]);

    let [viewFood, setViewFood] = useState(true);
    let [viewFoodBorder, setViewFoodBorder] = useState('2px solid black');
    let [viewDrinks, setViewDrinks] = useState(false);
    let [viewDrinkBorder, setViewDrinkBorder] = useState('none');
    let [viewHotel, setViewHotel] = useState(false);
    let [viewHotelBorder, setViewHotelBorder] = useState('none');
    let [viewMisc, setViewMisc] = useState(false);
    let [viewMiscBorder, setViewMiscBorder] = useState('none');


     function getProducts_food(product_type) {

        const requestOptions = {
                method: 'POST',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                },
                body: JSON.stringify({
                    Tracker: '74301_productList_restaurant_food',
                    user: acctID,
                    xInventoryProductType: product_type,
                    sessionID: sessionID,
                }),
            };
    
            fetch(baseURL + 'hotel_merchantAcct_argsjqApp', requestOptions)
                .then(res => res.text())
                .then(res => {
                    let rows = res.toString().split('~~~');
    
                    for (let rownum = 0; rownum < rows.length - 1; ++rownum) {
                        let cols = rows[rownum].split('|');
    

                        setViewInventoryAvailableProducts_food((prevAvailableProducts) => {
                            return prevAvailableProducts.concat({
                                productID: cols[0],
                                itemID_list: cols[1],
                                productType: cols[2],
                                productName: cols[3],
                                productPartNum: cols[4],
                                productPhoneNumber: cols[5],
                                productCostPerUnit: parseFloat(cols[6]).toFixed(2),
                                productSalePrice: parseFloat(cols[7]).toFixed(2),
                                productPic1: cols[8],
                                productPic2: cols[9],
                                productPic3: cols[10],
                                productPic4: cols[11],
                                productDateCreated: cols[12],
                                productAddedBy: cols[13],
                                productIsActivated: cols[14],


                            });
                        });
                    }
                });
    }

         function getProducts_drinks(product_type) {

        const requestOptions = {
                method: 'POST',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                },
                body: JSON.stringify({
                    Tracker: '74301_productList_restaurant_drinks',
                    user: acctID,
                    xInventoryProductType: product_type,
                    sessionID: sessionID,
                }),
            };
    
            fetch(baseURL + 'hotel_merchantAcct_argsjqApp', requestOptions)
                .then(res => res.text())
                .then(res => {
                    let rows = res.toString().split('~~~');
    
                    for (let rownum = 0; rownum < rows.length - 1; ++rownum) {
                        let cols = rows[rownum].split('|');
    

                        setViewInventoryAvailableProducts_drinks((prevAvailableProducts) => {
                            return prevAvailableProducts.concat({
                                productID: cols[0],
                                itemID_list: cols[1],
                                productType: cols[2],
                                productName: cols[3],
                                productPartNum: cols[4],
                                productPhoneNumber: cols[5],
                                productCostPerUnit: parseFloat(cols[6]).toFixed(2),
                                productSalePrice: parseFloat(cols[7]).toFixed(2),
                                productPic1: cols[8],
                                productPic2: cols[9],
                                productPic3: cols[10],
                                productPic4: cols[11],
                                productDateCreated: cols[12],
                                productAddedBy: cols[13],
                                productIsActivated: cols[14],


                            });
                        });
                    }
                });
    }

         function getProducts_hotel(product_type) {

        const requestOptions = {
                method: 'POST',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                },
                body: JSON.stringify({
                    Tracker: '74301_productList_restaurant_hotel',
                    user: acctID,
                    xInventoryProductType: product_type,
                    sessionID: sessionID,
                }),
            };
    
            fetch(baseURL + 'hotel_merchantAcct_argsjqApp', requestOptions)
                .then(res => res.text())
                .then(res => {
                    let rows = res.toString().split('~~~');
    
                    for (let rownum = 0; rownum < rows.length - 1; ++rownum) {
                        let cols = rows[rownum].split('|');
    

                        setViewInventoryAvailableProducts_hotel((prevAvailableProducts) => {
                            return prevAvailableProducts.concat({
                                productID: cols[0],
                                itemID_list: cols[1],
                                productType: cols[2],
                                productName: cols[3],
                                productPartNum: cols[4],
                                productPhoneNumber: cols[5],
                                productCostPerUnit: parseFloat(cols[6]).toFixed(2),
                                productSalePrice: parseFloat(cols[7]).toFixed(2),
                                productPic1: cols[8],
                                productPic2: cols[9],
                                productPic3: cols[10],
                                productPic4: cols[11],
                                productDateCreated: cols[12],
                                productAddedBy: cols[13],
                                productIsActivated: cols[14],


                            });
                        });
                    }
                });
    }

         function getProducts_misc(product_type) {

        const requestOptions = {
                method: 'POST',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                },
                body: JSON.stringify({
                    Tracker: '74301_productList_restaurant_misc',
                    user: acctID,
                    xInventoryProductType: product_type,
                    sessionID: sessionID,
                }),
            };
    
            fetch(baseURL + 'hotel_merchantAcct_argsjqApp', requestOptions)
                .then(res => res.text())
                .then(res => {
                    let rows = res.toString().split('~~~');
    
                    for (let rownum = 0; rownum < rows.length - 1; ++rownum) {
                        let cols = rows[rownum].split('|');
    

                        setViewInventoryAvailableProducts_misc((prevAvailableProducts) => {
                            return prevAvailableProducts.concat({
                                productID: cols[0],
                                itemID_list: cols[1],
                                productType: cols[2],
                                productName: cols[3],
                                productPartNum: cols[4],
                                productPhoneNumber: cols[5],
                                productCostPerUnit: parseFloat(cols[6]).toFixed(2),
                                productSalePrice: parseFloat(cols[7]).toFixed(2),
                                productPic1: cols[8],
                                productPic2: cols[9],
                                productPic3: cols[10],
                                productPic4: cols[11],
                                productDateCreated: cols[12],
                                productAddedBy: cols[13],
                                productIsActivated: cols[14],


                            });
                        });
                    }
                });
    }


    function activateRecipe()
    {
        
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: '74300_activateRecipe',
                user: acctID,
                xProductID: productID,
                xMenuType: menuType,
                sessionID: sessionID,
            })

            
        }

    
        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
            // alert(window.location.pathname)

           // let rows = res.toString().split('~~~');
           // let rowLength = rows.length
            
                
        })

    }

    function handleFood()
{
    setViewFood(true);
    setViewFoodBorder('2px solid black');

    setViewDrinks(false);
    setViewDrinkBorder('none');

    setViewHotel(false);
    setViewHotelBorder('none');

    setViewMisc(false);
    setViewMiscBorder('none');
}
function handleDrink()
{
    setViewFood(false);
    setViewFoodBorder('none');

    setViewDrinks(true);
    setViewDrinkBorder('2px solid black');

    setViewHotel(false);
    setViewHotelBorder('none');

    setViewMisc(false);
    setViewMiscBorder('none');
}

function handleHotel()
{
    setViewFood(false);
    setViewFoodBorder('none');

    setViewDrinks(false);
    setViewDrinkBorder('none');

    setViewHotel(true);
    setViewHotelBorder('2px solid black');

    setViewMisc(false);
    setViewMiscBorder('none');
}

function handleMisc()
{
    setViewFood(false);
    setViewFoodBorder('none');

    setViewDrinks(false);
    setViewDrinkBorder('none');

    setViewHotel(false);
    setViewHotelBorder('none');

    setViewMisc(true);
    setViewMiscBorder('2px solid black');
}

    function showRecipeDetailsModalHandler(event)
    {
        setProductID(event[1]);
        setProductName(event[2]);
        setShowProductDetails(true);
    }
    
    function closeModalHandler(event) {
        setViewInventoryAvailableProducts([]);
        props.closeModal(event);
    }
    function popOverHandler(event)
    {
        alert("in popoover handler");
        alert(event);

        setProductID(event[1]);
        alert(event);

        setvViewIonPopover(true);
    }

    function popOverSelection(event) {

        alert(event);

        setMenuType(event);
        setvViewIonPopover(false);
    }

    useEffect(() =>  {
            
        getProducts_food("food"); 
    
        getProducts_drinks("drinks");   
    
        getProducts_hotel("hotel"); 
    
        getProducts_misc("misc"); 
    
    }, [])
    
    return (
        <React.Fragment>
                    
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonHeader style={{color: "black"}}>
                <IonGrid>
                    <IonRow>
                        <IonCol size='3' style={{border: viewFoodBorder}} onClick={() => handleFood()}>
                            <IonText> FOOD </IonText>
                        </IonCol>
                        <IonCol size='3' style={{border: viewDrinkBorder}} onClick={() => handleDrink()}>
                            <IonText> DRINK </IonText>
                        </IonCol>
                        <IonCol size='3' style={{border: viewHotelBorder}} onClick={() => handleHotel()}>
                            <IonText> Hotel </IonText>
                        </IonCol>
                        <IonCol size='3' style={{border: viewMiscBorder}} onClick={() => handleMisc()}>
                            <IonText> Misc </IonText>
                        </IonCol>
                    </IonRow>
                    <IonRow style={{border: '2px solid black' }}>
                        <IonCol size='2'>
                            <h5> ID </h5>
                        </IonCol>
                        <IonCol size='6'>
                            <h5> Name </h5>
                        </IonCol>
                        {/*<IonCol size='3'>
                            <h5> Cost </h5>
                        </IonCol>*/}
                        <IonCol size='2'>
                            <h5> Total </h5>
                        </IonCol>
                        <IonCol size='2'>
                            <h5> Action </h5>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonHeader>
                <IonContent className='grid_content'>
                    <IonGrid >
                    {viewFood == true &&

                            viewInventoryAvailableProducts_food.map((detailData) => {
                                return (
                                    <IonRow key={detailData.productID}>
                                        <IonCol size='2'>{detailData.productID}</IonCol>
                                        <IonCol size='5'>{detailData.productName}</IonCol>
                                        <IonCol size='2'>{detailData.productSalePrice}</IonCol>
                                        <IonCol size='3'>
                                            <IonButton onClick={() => popOverHandler([true, detailData.productID])}>Add</IonButton>
                                            <IonButton onClick={() => showRecipeDetailsModalHandler([true, detailData.productID, detailData.productName])}>Details</IonButton>
                                        </IonCol>
                                    </IonRow>
                                );
                            })
                        }

                    {viewDrinks == true &&

                            viewInventoryAvailableProducts_drinks.map((detailData) => {
                                return (
                                    <IonRow key={detailData.productID}>
                                        <IonCol size='2'>{detailData.productID}</IonCol>
                                        <IonCol size='5'>{detailData.productName}</IonCol>
                                        <IonCol size='2'>{detailData.productSalePrice}</IonCol>
                                        <IonCol size='3'>
                                            <IonButton onClick={() => popOverHandler([true, detailData.productID])}>Add</IonButton>
                                            <IonButton onClick={() => showRecipeDetailsModalHandler([true, detailData.productID, detailData.productName])}>Details</IonButton>
                                        </IonCol>
                                    </IonRow>
                                );
                            })
                        }
                    {viewHotel == true &&

                            viewInventoryAvailableProducts_hotel.map((detailData) => {
                                return (
                                    <IonRow key={detailData.productID}>
                                        <IonCol size='2'>{detailData.productID}</IonCol>
                                        <IonCol size='5'>{detailData.productName}</IonCol>
                                        <IonCol size='2'>{detailData.productSalePrice}</IonCol>
                                        <IonCol size='3'>
                                            <IonButton onClick={() => popOverHandler([true, detailData.productID])}>Add</IonButton>
                                            <IonButton onClick={() => showRecipeDetailsModalHandler([true, detailData.productID, detailData.productName])}>Details</IonButton>
                                        </IonCol>
                                    </IonRow>
                                );
                            })
                        }
                    {viewMisc == true &&

                            viewInventoryAvailableProducts_misc.map((detailData) => {
                                return (
                                    <IonRow key={detailData.productID}>
                                        <IonCol size='2'>{detailData.productID}</IonCol>
                                        <IonCol size='5'>{detailData.productName}</IonCol>
                                        <IonCol size='2'>{detailData.productSalePrice}</IonCol>
                                        <IonCol size='3'>
                                            <IonButton onClick={() => popOverHandler([true, detailData.productID])}>Add</IonButton>
                                            <IonButton onClick={() => showRecipeDetailsModalHandler([true, detailData.productID, detailData.productName])}>Details</IonButton>
                                        </IonCol>
                                    </IonRow>
                                );
                            })
                        }
                        </IonGrid>

                        {viewIonPopover == true && (
                            <div
                            style={{
                            position: 'absolute',
                            width: '75%',
                            height: '50%',
                            backgroundColor: 'white',
                            transform: 'translate(10%, 0%)',
                            padding: '16px',
                            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                            zIndex: 1000,
                            borderRadius: '8px',       /* Rounded corners */
                            border: '2px rgb(0, 0, 0) solid',
                            }}
                            >

                            <IonGrid>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <IonText>SELECT MENU TYPE</IonText>
                                        </IonCol>
                                        <IonCol size='6'>
                                        <select name="paymenttype" id='paymenttype' onChange={(e) => popOverSelection(e.target.value) }>
                                            <option value='null' selected='selected'>Make Selection</option>
                                            <option value='food' >Food</option>
                                            <option value='drinks'>Drinks</option>
                                        </select>
                                        </IonCol>
                                    </IonRow>

                            </IonGrid>
                            </div>
                            )}   

            {showProductDetails == true &&  <ViewRecipeDetailDataModal openModal={ showProductDetails } closeModal={() => setShowProductDetails(false)} data={{
                                    productID: productID, 
                                    productName: productName
                                    }}>
                                </ViewRecipeDetailDataModal>}
                                
            </IonContent>
            <IonFooter class='grid_footer'>
                <IonGrid>
                    <IonRow>
                        <IonCol size="6">
                            <IonButton onClick={() => activateRecipe()}>Submit </IonButton>
                        </IonCol>
                        <IonCol size="6">
                            <IonButton onClick={() => closeModalHandler()}>Cancel </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
        </IonFooter>
        </IonModal>
        ) : null}
    
        </React.Fragment>

    )
}